import {ChangeDetectionStrategy, Component, EventEmitter, inject, input, OnInit, Output} from '@angular/core';
import {MatIconModule} from "@angular/material/icon";
import {AuthStore} from "@features/auth/auth.store";
import {AuthSessionService} from "@features/auth/auth-session.service";
import {MatDividerModule} from "@angular/material/divider";
import {ProfileStore} from "@features/profile";

@Component({
  selector: 'app-profile-menu',
  imports: [
    MatIconModule,
    MatDividerModule,
  ],
  templateUrl: './profile-menu.component.html',
  styleUrl: './profile-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileMenuComponent implements OnInit{
  protected authStore = inject(AuthStore);
  protected profileStore = inject(ProfileStore);
  private authSession = inject(AuthSessionService);

  showHeader = input(false);
  @Output() profileClosed = new EventEmitter<void>();

  logout() {
    this.authSession.logout();
  }

  ngOnInit(): void {
    this.profileStore.ensureCurrentUser();
  }


}
